import { render, staticRenderFns } from "./ai.vue?vue&type=template&id=c5b17956&scoped=true"
import script from "./ai.vue?vue&type=script&lang=ts"
export * from "./ai.vue?vue&type=script&lang=ts"
import style0 from "./ai.vue?vue&type=style&index=0&id=c5b17956&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b17956",
  null
  
)

export default component.exports